import { Injectable } from '@angular/core';
import { Payment } from '../../domain/models/payment.model';
import { PaymentDto } from '../dtos/payment.dto';

@Injectable()
export class PaymentMapper {
  public toPayment(dto: PaymentDto): Payment {
    return {
      externalId: dto.ExternalId,
      externalUrl: dto.ExternalUrl,
      invoiceId: dto.InvoiceId,
      invoiceNumber: dto.InvoiceNumber,
      paymentType: dto.PaymentType,
      paymentMethod: dto.PaymentMethod,
      paid: dto.Paid,
      status: dto.Status,
      dateAdded: dto.DateAdded,
      createdAtUtc: dto.Created,
      modifiedAtUtc: dto.Modified,
    };
  }
}
